import Axios from 'axios';
import qs from 'qs';
import { Message } from 'element-ui';
import store from '../../store';

export class Http {
  httpClient = Axios.create({
    baseURL: this.baseUrl,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
    },
    withCredentials:true
  });

  get baseUrl() {
    return 'https://api.goodyiyao.cn/web/';
    // return process.env.NODE_ENV === 'production'? AppConfig.productionURL: AppConfig.developmentURL;
  }

  post(url, data = {}, headers) {
    return new Promise((resolve, reject) => {
      data.token = data.token || localStorage.getItem('token');
      this.httpClient.post(url, qs.stringify(data), { headers}).then((response) => {
        const result = this.parse(response.data);
        if (response.status === 200 && result.errcode === 0) {
          resolve(result.data);
        } else {
          this.unifyError(reject, url)(response.data);
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  get(url, data = {}, headers = { 'Content-Disposition': `attachment; filename="packeg.zip"`}) {
    return new Promise((resolve, reject) => {
      data.token = data.token || localStorage.getItem('token');
      const queryParams = this.objectToUrlString(data || {});
      this.httpClient.get(`${url}${queryParams? '?' + queryParams: ''}`, { headers }).then((response) => {
        const result = this.parse(response.data);
        if (response.status === 200 && result.errcode === 0) {
          resolve(this.parse(result.data));
        } else {
          this.unifyError(reject, url)(response.data);
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  upload(url, data = {}, headers = { 'content-type': 'multipart/form-data' }) {
    return new Promise((resolve, reject) => {
      data.token = data.token || localStorage.getItem('token');
      const formData = new FormData();
      for(let key of Object.keys(data)) {
        formData.set(key, data[key]);
      }
      this.httpClient.post(url, formData, { headers}).then((response) => {
        const result = this.parse(response.data);
        if (response.status === 200 && result.errcode === 0) {
          resolve(result.data);
        } else if (response.status === 200 && result.state === 'SUCCESS') {
          resolve(result);
        } else {
          this.unifyError(reject, url)(response.data);
        }
      }).catch(this.unifyError(reject, url));
    });
  }

  // 以下方法属于工具函数

  unifyError(reject, url) {
    return (error) => {
      Message.error({message: error.msg})
      if (error.errcode === 10001 && url !== '/login') {
        localStorage.clear();
        store.commit('calculationNumber', 0);
        location.reload();
        store.commit('SET_NAME','');
        Message.warning({message: '请登录'});
      }
      reject(error);
      console.log(error, url);
    };
  }

  parse(data) {
    return typeof data === 'string'? JSON.parse(data): data;
  }

  objectToUrlString = (obj, encode = false) => {
    const result = [];
    for (const item in obj) {
      result.push(`${item}=${encode? encodeURIComponent(obj[item]): obj[item]}`);
    }
    return result.join('&');
  }

}
